export * from 'c1ui/components/C1Dialog/C1Dialog'

export type closeFunction = (event?: object, reason?: 'backdropClick' | 'escapeKeyDown', success?: boolean) => void
